import { render } from "./AppNotifications.vue?vue&type=template&id=37a1de22&scoped=true"
import script from "./AppNotifications.vue?vue&type=script&lang=js"
export * from "./AppNotifications.vue?vue&type=script&lang=js"

import "./AppNotifications.vue?vue&type=style&index=0&id=37a1de22&scoped=true&lang=css"

import exportComponent from "/tmp/build_61b3eac7/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a1de22"]])

export default __exports__